// extracted by mini-css-extract-plugin
export default {"policies-wrap":"policies-wrap-s3EWS","panel":"panel-OAA9Z"};